import type { Specialty } from '@/hooks/query/useQuerySpecialties';
import type { ClinicianTypeInput } from '@heidi/workspace/contracts';

type SpecialtyIdentifyTraits = {
  specialty: Specialty | null;
  /**
   * Kept for historical reasons only: no longer necessary now that the
   * localized specialty name lives on `specialty` itself as `localizedName`.
   * Same wire shape as before — an item whose `name` is the localized string.
   */
  localised_specialty: ClinicianTypeInput | null;
};

/**
 * Derives the `specialty` / `localised_specialty` analytics identify traits
 * from the unified specialties list — the single source shared by the three
 * auth providers (auth.tsx, fhir-auth.tsx, tauriAuth.tsx).
 */
export function getSpecialtyIdentifyTraits(
  specialtyId: string | null | undefined,
  specialties: Specialty[] | undefined
): SpecialtyIdentifyTraits {
  const userSpecialty =
    specialtyId && specialties
      ? (specialties.find((specialty) => specialty.id === specialtyId) ?? null)
      : null;
  return {
    specialty: userSpecialty,
    localised_specialty: userSpecialty
      ? { ...userSpecialty, name: userSpecialty.localizedName }
      : null,
  };
}
